import React from 'react';
// @ts-ignore FIXME: Try `npm install @types/rc-form` if it exists or a... Remove this comment to see the full error message
import { formShape } from 'rc-form';
import LocationInterface from '@solvhealth/types/interfaces/Location';
import { GenericObj } from '@solvhealth/types/interfaces/generics';
import { PaperworkCopyFormFieldsCheckboxName } from '../paperworkConstants';
import PaperworkCopyFormFieldsCheckbox from '../components/PaperworkCopyFormFieldsCheckbox';
import { getStandardFormFieldData, isPaperworkForChild, PaperworkField } from '.';
import { useSolvSelector } from '~/reducers';
import { validateFamilyBooking } from '../../../util/validateFamilyBooking';
import { usePaperworkContextBookingId } from '~/routes/paperwork/PaperworkBookingIdContext';
import { CheckboxMeta } from '../hooks';

type Props = {
  form: formShape;
  fieldNames: string[];
  preloadedData?: any;
  toggleSideEffect?: any;
  checkboxEnabled?: boolean;
  checkboxMeta?: CheckboxMeta;
};

const paperworkCopyFormFieldsCheckboxNameSet = new Set(
  Object.values(PaperworkCopyFormFieldsCheckboxName)
);
const CHECKBOXES_FOR_ALL_PAPERWORK = [
  PaperworkCopyFormFieldsCheckboxName.GUARDIAN_ADDRESS,
  PaperworkCopyFormFieldsCheckboxName.GUARANTOR_INFO,
];

const PaperworkFields = (props: Props) => {
  const { form, fieldNames, preloadedData, toggleSideEffect, checkboxEnabled, checkboxMeta } =
    props;

  const bookingId = usePaperworkContextBookingId();
  const booking = useSolvSelector((state) => state.pastBookings[bookingId]);
  const location = useSolvSelector((state) => state.location as LocationInterface);
  const paperwork = useSolvSelector((state) => state.paperwork);

  const { isPrimary, isFamilyBooking } = validateFamilyBooking(booking);

  return (
    <>
      {fieldNames.map((fieldName: string, index: number) => {
        if (
          paperworkCopyFormFieldsCheckboxNameSet.has(
            fieldName as PaperworkCopyFormFieldsCheckboxName
          )
        ) {
          if (
            (isFamilyBooking && isPrimary) ||
            (!isFamilyBooking &&
              !CHECKBOXES_FOR_ALL_PAPERWORK.includes(
                fieldName as PaperworkCopyFormFieldsCheckboxName
              )) ||
            !isPaperworkForChild(
              paperwork.formData,
              preloadedData.userProfile,
              preloadedData.newBooking
            )
          ) {
            return null;
          }
          return (
            <PaperworkCopyFormFieldsCheckbox
              booking={booking}
              checkboxEnabled={checkboxEnabled}
              checkboxMeta={checkboxMeta}
              checkboxName={fieldName as PaperworkCopyFormFieldsCheckboxName}
              form={form}
              key={fieldName}
              noTopMargin={index === 0}
              toggleSideEffect={toggleSideEffect}
            />
          );
        }
        return (
          <PaperworkField
            key={fieldName}
            {...{
              field: getStandardFormFieldData(fieldName, paperwork),
              paperwork,
              form,
              preloadedData,
              location,
            }}
          />
        );
      })}
    </>
  );
};

export default PaperworkFields;
